module.exports = __webpack_public_path__ + "static/media/boiraEspessa.54986b07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/boiraEspessa.svg
// module id = 828
// module chunks = 0